import { Component, OnInit } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Title, Meta } from '@angular/platform-browser';

import { CorporateTravelType01Component } from './corporate-travel-type01/corporate-travel-type01.component';
import { CorporateTravelType02Component } from './corporate-travel-type02/corporate-travel-type02.component';

@Component({
  selector: 'app-corporate-travel',
  standalone: true,
  imports: [CorporateTravelType01Component, CorporateTravelType02Component],
  templateUrl: './corporate-travel.component.html',
  styleUrl: './corporate-travel.component.scss'
})
export class CorporateTravelComponent implements OnInit {

  public view: any = {

  }

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta){}

  ngOnInit(): void {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      console.log('Site: ', this.view.site);

      if (this.view.site) {
        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);
      }

    });

    this._tfmService.getContentBySection('corporate-travel').then(res => {
      this.view.page = res;
      console.log('Page: ', this.view.page);

      if (this.view.page && this.view.site) {

        //Set title
        this.title.setTitle(this.view.page.content.name + " - " + this.view.site.name);

        // Set description & keywords
        this.metaService.updateTag( { name:'description', content:this.view.page.content.seo.description});
        this.metaService.updateTag( { name:'keywords', content:this.view.page.content.seo.keywords});
      }
    });
      
  }

}
